import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IProjects, IProjectsState, TError } from './types/projects-interface';
import { fetchProjects, fetchProjectsDownload } from './actions/fetch-projects';


const initialState: IProjectsState = {
    Projects: [],
    ProjectsCount: 0,
    isLoadingProjects: false,
    errorProjects: [],
    currentPage: 1,
    isDownloadProjects: false,
    errorDownloadProjects: [],
    FileData: "",
    FileName: ""
};

export const projetcs = createSlice({
    name: 'projetcs',
    initialState,
    reducers: {
        resetListData: (state) => {
            state.Projects= [];
            state.ProjectsCount = 0;
            state.isLoadingProjects = false;
            state.errorProjects = [];
            state.currentPage = 1;
            state.isDownloadProjects = false;
            state.errorDownloadProjects = [];
            state.FileData = "";
            state.FileName = "";
        },
        setCurrentPage: (state, action: PayloadAction<{ page: number }>) => {
            state.currentPage = action.payload.page;
        },
        resetFileData: (state) => {
            state.Projects = state.Projects;
            state.ProjectsCount = state.ProjectsCount;
            state.isLoadingProjects = state.isLoadingProjects;
            state.errorProjects = state.errorProjects;
            state.currentPage = state.currentPage;
            state.isDownloadProjects = false;
            state.errorDownloadProjects = [];
            state.FileData = "";
            state.FileName = "";
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchProjects.pending, (state) => {
                state.isLoadingProjects = true;
            })
            .addCase(fetchProjects.fulfilled, (state, action: PayloadAction<{ Projects: IProjects[], ProjectCount: number }>) => {
                state.isLoadingProjects = false;
                state.Projects = action.payload.Projects;
                state.ProjectsCount = action.payload.ProjectCount;
                state.errorProjects = [];
                state.currentPage = state.currentPage;
            })
            .addCase(fetchProjects.rejected, (state, action) => {
                state.Projects = [];
                state.ProjectsCount = 0;
                state.isLoadingProjects = false;
                state.errorProjects = action.payload as TError;
                state.currentPage = 1;
            })
            .addCase(fetchProjectsDownload.pending, (state) => {
                state.isDownloadProjects = true;
            })
            .addCase(fetchProjectsDownload.fulfilled, (state, action: PayloadAction<{ FileData: string, FileName: string }>) => {
                state.isDownloadProjects = false;
                state.FileData = action.payload.FileData;
                state.FileName = action.payload.FileName;
                state.errorDownloadProjects = [];
            })
            .addCase(fetchProjectsDownload.rejected, (state, action) => {
                state.FileData = '';
                state.FileName = '';
                state.isDownloadProjects = false;
                state.errorDownloadProjects = action.payload as TError;
            });
    },
});

export const { resetListData, setCurrentPage, resetFileData } = projetcs.actions;
export default projetcs.reducer;